module.exports = __webpack_public_path__ + "static/media/Pennal.a7a96cb2.PNG";